export const colors = {
    "divider": "hsla(240, 4.7%, 25.1%, 1.000)",
    "menu": {
        "active": "hsla(215, 66.3%, 59.2%, 1.000)",
        "hover": "hsla(215, 19.1%, 36.9%, 1.000)",
        "default": "hsla(215, 19.1%, 36.9%, 0.000)"
    },
    "icons": {
        "subtle": "hsla(207, 4.8%, 37.1%, 1.000)",
        "dimmed": "hsla(0, 0%, 65.1%, 1.000)",
        "inverse": "hsla(0, 0%, 25.1%, 1.000)",
        "mono": "hsla(0, 0%, 100%, 1.000)",
        "danger": "hsla(0, 100%, 70%, 1.000)",
        "primary": "hsla(205, 100%, 65.1%, 1.000)"
    },
    "status": {
        "good": "hsla(126, 48.1%, 68.2%, 1.000)"
    },
    "input": {
        "border": {
            "default": "hsla(120, 1.3%, 85.3%, 1.000)"
        }
    }
};